module.exports = __webpack_public_path__ + "img/1.6401b001.png";